import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
function WorkflowStage() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [workflowList, setWorkflowList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        id: "",
        workflow: "",
        stage_no: "",
        stage_name: "",
        group: "",
        can_reject: true,
        can_send_back: true,
        sequence: "",
        addedby: userName,
        ip_add: ipAddress
    });
    useEffect(() => {
        getWorkflow();
        getGroups();
        getWorkflowStage();
    }, []);
    const getWorkflow = () => {
        axios
            .get(baseUrl + "workflow/")
            .then((res) => {
                setWorkflowList(res.data);
            });
    };
    const getGroups = () => {
        axios
            .get(baseUrl + "groups/")
            .then((res) => {
                setGroupList(res.data);
            });
    };
    const getWorkflowStage = () => {
        setLoading(true);
        axios
            .get(baseUrl + "workflow-stage/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire("Error", "Unable to load workflow stages", "error");
            });
    };
    const handleChange = (e) => {
        const {
            name, value, type, checked
        } = e.target;
        setFormData({
            ...formData, [name]: type === "checkbox" ? checked : value
        });
    };
    const openModal = (row = null) => {
        if (row) {
            setFormData({
                id: row.id,
                workflow: row.workflow?.id || row.workflow,
                stage_no: row.stage_no,
                stage_name: row.stage_name,
                group: row.group?.id || row.group,
                can_reject: row.can_reject,
                can_send_back: row.can_send_back,
                sequence: row.sequence,
                addedby: userName,
                ip_add: ipAddress
            });
        } else {
            setFormData({
                id: "",
                workflow: "",
                stage_no: "",
                stage_name: "",
                group: "",
                can_reject: true,
                can_send_back: true,
                sequence: "",
                addedby: userName,
                ip_add: ipAddress
            });
        }
        setShowModal(true);
    };
    const closeModal = () => {
        setShowModal(false);
    };
    const saveWorkflowStage = () => {
        const data = new FormData();
        data.append("workflow", formData.workflow);
        data.append("stage_no", formData.stage_no);
        data.append("stage_name", formData.stage_name);
        data.append("group", formData.group);
        data.append("can_reject", formData.can_reject);
        data.append("can_send_back", formData.can_send_back);
        data.append("sequence", formData.sequence);
        data.append("addedby", userName);
        data.append("ip_add", ipAddress);
        if (formData.id) {
            axios
                .put(baseUrl + `workflow-stage/${formData.id}/`, data)
                .then(() => {
                    Swal.fire("Success", "Workflow Stage updated", "success");
                    closeModal();
                    getWorkflowStage();
                });
        } else {
            axios
                .post(baseUrl + "workflow-stage/", data)
                .then(() => {
                    Swal.fire("Success", "Workflow Stage created", "success");
                    closeModal();
                    getWorkflowStage();
                });
        }
    };
    const deleteStage = (id) => {
        Swal.fire({
            title: "Delete Stage?", icon: "warning", showCancelButton: true, confirmButtonText: "Delete"
        })
            .then((result) => {
                if (result.isConfirmed) {
                    axios
                        .delete(`workflow-stage/${id}/`)
                        .then(() => {
                            Swal.fire("Deleted", "Stage deleted", "success");
                            getWorkflowStage();
                        });
                }
            });
    };
    const columns = [{
        field: "id", headerName: "ID", width: 80
    }, {
        field: "workflow", headerName: "Workflow", flex: 1, renderCell: (params) => (params.row.workflow?.workflow_name)
    }, {
        field: "stage_no", headerName: "Stage No", width: 100
    }, {
        field: "stage_name", headerName: "Stage Name", flex: 1
    }, {
        field: "group", headerName: "Group", flex: 1, renderCell: (params) => (params.row.group?.name)
    }, {
        field: "sequence", headerName: "Sequence", width: 100
    }, {
        field: "action", headerName: "Action", width: 180, renderCell: (params) => (<>

                <button
                    className="btn btn-sm btn-primary me-2"
                    onClick={() => openModal(params.row)}
                >
                    Edit
                </button>


                <button
                    className="btn btn-sm btn-danger"
                    onClick={() => deleteStage(params.row.id)}
                >
                    Delete
                </button>

            </>)
    }];
    return (<div className="container-fluid mt-3">


            <div className="card shadow">


                <div className="card-header bg-primary text-white d-flex justify-content-between">


                    <h5>
                        Workflow Stage Master
                    </h5>


                    <button
                        className="btn btn-light"
                        onClick={() => openModal()}
                    >
                        + Add Stage
                    </button>


                </div>


                <div className="card-body">


                    <div
                        style={{
                            height: 600, width: "100%"
                        }}
                    >


                        <ERPDataGrid

                            rows={rows}

                            columns={columns}

                            loading={loading}

                            getRowId={(row) => row.id}


                            pageSizeOptions={[10, 25, 50, 100]}

                            disableRowSelectionOnClick

                        />


                    </div>


                </div>


            </div>


            {showModal && (<div
                    className="modal fade show"
                    style={{
                        display: "block", background: "rgba(0,0,0,.5)"
                    }}
                >


                    <div className="modal-dialog modal-lg modal-dialog-centered">


                        <div className="modal-content">


                            <div className="modal-header">


                                <h5>
                                    Workflow Stage
                                </h5>


                                <button
                                    className="btn-close"
                                    onClick={closeModal}
                                />


                            </div>


                            <div className="modal-body">


                                <div className="row">


                                    <div className="col-md-6 mb-3">

                                        <label>
                                            Workflow
                                        </label>


                                        <select
                                            className="form-select"
                                            name="workflow"
                                            value={formData.workflow}
                                            onChange={handleChange}
                                        >

                                            <option value="">
                                                Select Workflow
                                            </option>


                                            {workflowList.map((w) => (<option
                                                    key={w.id}
                                                    value={w.id}
                                                >
                                                    {w.workflow_name}
                                                </option>))}


                                        </select>


                                    </div>


                                    <div className="col-md-3 mb-3">

                                        <label>
                                            Stage No
                                        </label>


                                        <input
                                            className="form-control"
                                            name="stage_no"
                                            value={formData.stage_no}
                                            onChange={handleChange}
                                        />


                                    </div>


                                    <div className="col-md-3 mb-3">

                                        <label>
                                            Sequence
                                        </label>


                                        <input
                                            className="form-control"
                                            name="sequence"
                                            value={formData.sequence}
                                            onChange={handleChange}
                                        />


                                    </div>


                                    <div className="col-md-6 mb-3">


                                        <label>
                                            Stage Name
                                        </label>


                                        <input
                                            className="form-control"
                                            name="stage_name"
                                            value={formData.stage_name}
                                            onChange={handleChange}
                                        />


                                    </div>


                                    <div className="col-md-6 mb-3">


                                        <label>
                                            Group
                                        </label>


                                        <select
                                            className="form-select"
                                            name="group"
                                            value={formData.group}
                                            onChange={handleChange}
                                        >


                                            <option value="">
                                                Select Group
                                            </option>


                                            {groupList.map((g) => (<option
                                                    key={g.id}
                                                    value={g.id}
                                                >
                                                    {g.name}
                                                </option>))}


                                        </select>


                                    </div>


                                    <div className="col-md-6">


                                        <div className="form-check">

                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                name="can_reject"
                                                checked={formData.can_reject}
                                                onChange={handleChange}
                                            />

                                            <label>
                                                Can Reject
                                            </label>

                                        </div>


                                    </div>


                                    <div className="col-md-6">


                                        <div className="form-check">

                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                name="can_send_back"
                                                checked={formData.can_send_back}
                                                onChange={handleChange}
                                            />

                                            <label>
                                                Can Send Back
                                            </label>

                                        </div>


                                    </div>


                                </div>


                            </div>


                            <div className="modal-footer">


                                <button
                                    className="btn btn-secondary"
                                    onClick={closeModal}
                                >
                                    Close
                                </button>


                                <button
                                    className="btn btn-success"
                                    onClick={saveWorkflowStage}
                                >
                                    Save
                                </button>


                            </div>


                        </div>


                    </div>


                </div>)}


        </div>);
}
export default WorkflowStage;